// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabLink--mU_Io6p6 {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  transition: none;\n  color: var(--text-color-default);\n}\n\n.customAnimation--3g3CUW_B {\n  animation-duration: 0s !important;\n}\n\n.customAnimation--3g3CUW_B {\n  z-index: 999;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabLink": "tabLink--mU_Io6p6",
	"customAnimation": "customAnimation--3g3CUW_B"
};
export default ___CSS_LOADER_EXPORT___;
